import React from 'react';

import './PageNotFound.scss';

const PageNotFound = () => (
    <div className="page-not-found-container">
        <span id="message">Invalid URL</span>
        <p>Please enter a valid URL to access the page or<br/>
        Contact support team <span>Self-Healing.Automation.Support@albertsons.com</span> for assitance.</p>
    </div>
)

export default PageNotFound;